
const commonConfig = {
    COMPANY_NAME: '盛世创富保险商城管理后台',
    CALLBACK_CODE: {
        SUCCESS: 0,
        VALIDATE_ERROR: 100003,
        AUTH_FAIL: 300002,
        LOGIN_FAIL: 300000,
        EXCEL_FORMAT_ERROR: 600001
    }
};

export default commonConfig;


// WEBPACK FOOTER //
// ./src/config/index.js